<template>
	<div class="c-newsletterSignup">
		<div class="c-newsletterSignup__form" v-if="isForm">
			<div class="c-newsletterSignup__text">
				<h2>{{ heading }}</h2>
				{{ text }}
			</div>
			<div class="c-newsletterSignup__email">
				<div class="o-input">
					<input
						class="o-input__input"
						type="email"
						name="email"
						v-model="email"
						:class="{
							'o-input__input--filled': email,
						}"
					/>
					<div class="o-input__label">
						{{ translations['Email'] }}
					</div>
				</div>
				<div
					class="c-newsletterSignup__email__apply"
					:class="{ loading: isLoading }"
					@click="SignUp()"
				>
					{{ translations['Sign up'] }}
					<inline-loader></inline-loader>
				</div>
			</div>
		</div>
		<div class="c-newsletterSignup__success" v-if="isSuccess">
			<div class="c-newsletterSignup__text">
				<h2>{{ successheading }}</h2>
				{{ successtext }}
			</div>
			<div class="o-btn c-newsletterSignup__button" @click="toForm()">
				Okay
			</div>
		</div>
		<div class="c-newsletterSignup__fail" v-if="isFail">
			<div class="c-newsletterSignup__text">
				<h2>{{ message }}</h2>
			</div>
			<div class="o-btn c-newsletterSignup__button" @click="toForm()">
				Prøv igen
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

import InlineLoader from './InlineLoader.vue'

export default {
    name: 'NewsletterSignup',
    components: {
		InlineLoader,
    },
    props: {
		heading: String,
		text: String,
		successheading: String,
		successtext: String
    },
    data: () => {
        return {
			isLoading: false,
			isForm: true,
			isFail: false,
			isSuccess: false,
			message: '',
			email: '',
        }
    },
	methods: {
		SignUp(){
			this.isLoading = true;

			const formData = new FormData()
			formData.append('action', 'mailchimp-subscribe/audience/subscribe')
			formData.append('audienceId', 'abb5dc7e4c')
			formData.append('CRAFT_CSRF_TOKEN', this.csrf)
			formData.append('email', this.email)

			axios.post(document.location.href, formData)
			.then((res) => {
				if(res.data.success == true){
					this.isLoading = false;
					this.isForm = false;
					this.isSuccess = true;
				}
				else if(res.data.success == false){
					this.isLoading = false;
					this.isFail = true;
					this.isForm = false;
					if(res.data.message == "Invalid email"){
						this.message = "Ugyldig E-mail"
					}else{
						this.message = res.data.message
					}
				}
				else{
					this.isLoading = false;
					this.isFail = true;
					this.isForm = false;
					this.message = 'Der skete en fejl, prøv igen';
				}
			});
		},
		toForm(){
			this.isFail = false
			this.isSuccess = false
			this.isForm = true
			this.message = '';
			this.email = '';
		}
	},
	computed: {
        ...mapState({
            csrf: (state) => state.app.csrfToken,
            translations: (state) => state.app.translations,
        }),
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-newsletterSignup{
	min-height: 250px;
	display: flex;
	align-items: center;
	justify-content: center;

	&__button{
		margin-top: 30px;
	}
	&__email{
		display: flex;
		margin-top: 30px;

		.o-input__input {
            border-radius: 4px 0 0 4px;
        }

		&__apply {
			position: relative;
			padding: 10px 30px 10px 30px;
			color: $c-white;
			font-family: $font-heading;
			font-size: 17px;
			letter-spacing: -0.13px;
			line-height: 18px;
			text-align: center;
			background: $c-black;
			border-radius: 0 4px 4px 0;
			display: flex;
			align-items: center;
			&:hover {
				cursor: pointer;
			}

			&.loading {
				&::before {
					position: absolute;
					display: block;
					background: $c-black;
					content: '';
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
				}

				.o-loaderInline {
					display: inline-block;
				}
			}

			.o-loaderInline {
				position: absolute;
				display: none;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%) scale(0.3);
				margin-left: -5px;
				z-index: 3;

				div {
					background: $c-white;
				}
			}
		}
	}
}
</style>
